import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { BaseReactComponent } from "../../utils/form";
import { Col, Row, Table } from "react-bootstrap";

import { Image } from "react-bootstrap";
import ComponentHeader from "../common/ComponentHeader";
import { durationObj } from "../../utils/Constant";
import { getDetailsTemplateApi, getSubdomainDetailsApi, getTemplateDetailsApi } from "./Api";
import { withRouter } from "../../utils/hoc/withRouter";


class ViewTemplatesTab extends BaseReactComponent {
    constructor(props) {
        super(props);
        // const detail = props?.location.state?.data || null;

        const { params } = props.match;
        this.state = {
            params,
            data: {},
            templateUuid: "",
            isUpdated: (props?.location.state ?? false) || false,
            templateName: "",
            thumbnailPath: "",
            thumbnailFile: null,
            showSearchContent: false,
            search: '',
            locationSearch: '',
            resLoading: false,
            loading: false,


        };
    }

    componentDidMount() {
        getDetailsTemplateApi("/contentTemplate", this);


    }
    render() {
        const { data } = this.state;
        console.log(data)


        return (
            <section className="user-section">
                {/* // ---------------------------------------View details -------------------------------- */}

                <div className="view-details-wrapper">

                    <ComponentHeader title="View Template " isBackArrow={true} isReturn="/template" />
                    <div className="view-details d-flex">
                        <div className="view-details-content">
                            <div className="user-details d-flex">
                                <div className="eclipse">
                                    <Image src={data?.thumbnailImage} className="eclipse" />
                                </div>
                                <div className="name-details">
                                    <h3 className="inter-medium f-s-20">{data?.templateName || ""}</h3>

                                </div>
                                <div className="line"></div>
                                <div className="name-description">
                                    <h3 className="grey-2 ">About</h3>
                                    <p className="inter-medium f-s-14">
                                        {data?.description}
                                    </p>
                                </div>
                            </div>
                            <h3 className="inter-regular f-s-14 grey-2">
                                Template Details
                            </h3>
                            <div className="line2"></div>
                            <Table className="custom-table">
                                <Row>
                                    <Col sm={3} xs={12}>
                                        <div className="detail">
                                            <h4 className="inter-semibold grey-2 ">Template Name</h4>
                                            <h3 className="inter-semibold f-s-14 ">{data?.templateName}</h3>
                                        </div>
                                    </Col>
                                    <Col sm={3} xs={12}>
                                        <div className="detail">
                                            <h4 className="inter-semibold grey-2 ">Description</h4>
                                            <h3 className="inter-semibold f-s-14 ">{data?.description}</h3>
                                        </div>
                                    </Col>

                                    <Col sm={3} xs={12}>
                                        <div className="detail">
                                            <h4 className="inter-semibold grey-2 ">Dimension</h4>
                                            <h3 className="inter-semibold f-s-14 ">{data?.personalizationDimension?.dimensionName || ''}</h3>
                                        </div>
                                    </Col>

                                    <Col sm={3} xs={12}>
                                        <div className="detail">
                                            <h4 className="inter-semibold grey-2 ">Is Verified</h4>
                                            <h3 className="inter-semibold f-s-14 ">{data?.isVerified ? "Yes" : "No" || ''}</h3>
                                        </div>
                                    </Col>

                                </Row>

                            </Table>

                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = (state) => ({ personalizationState: state.PersonalizationState });
const mapDispatchToProps = {
    // getPosts: fetchPosts
};
ViewTemplatesTab.propTypes = {
    // getPosts: PropTypes.func
    location: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewTemplatesTab));

